<template>
  <main class="container-fluid">
    <div>
      <h4 class="nes blue">Not found</h4>
      <div class="mt2">How do you make <q>one</q> vanish?</div>
      <div class="text-muted mt-1">Prepend <q>g</q> and it's gone.</div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
</style>
